// extracted by mini-css-extract-plugin
var _1 = "YtwdY";
var _2 = "C5hfZ";
var _3 = "obDoV";
export { _1 as "modalContent", _2 as "modalFooter", _3 as "modalTitle" }
